import staticAssetDeploymentVersion from '@/lib/staticAssetDeploymentVersion';

function normalizeAssetPath(assetPath: string): string {
  return assetPath.replace(/^\/+/, '');
}

function normalizeBaseUrl(baseUrl: string): string {
  return baseUrl.replace(/\/+$/, '');
}

const { resolveRuntimeStaticAssetDeploymentVersion } = staticAssetDeploymentVersion;

export function getVersionedPublicAssetUrl(assetPath: string, fallbackOrigin?: string): string {
  const normalizedAssetPath = normalizeAssetPath(assetPath);
  const deploymentVersion = resolveRuntimeStaticAssetDeploymentVersion();
  const relativePath = `/assets/${deploymentVersion}/${normalizedAssetPath}`;

  if (!fallbackOrigin) {
    return relativePath;
  }

  return `${normalizeBaseUrl(fallbackOrigin)}${relativePath}`;
}
